import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { SERVER_URL } from "../../../../api";
import {
	changeStatusFoodPlate,
	deleteFoodPlate,
	getFoodPlates,
} from "../../../../api/foodPlate";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import Table, {
	buttonsStyle,
	dateFormatter,
	substringFormatter,
} from "../../../components/tables/table";

function getData(foodPlates) {
	let data = [];
	for (let i = 0; i < foodPlates.length; ++i) {
		const elem = {};
		elem.description = getNonEmpty(foodPlates[i].description);
		elem.emptylanguages = (foodPlates[i].description.en? "":"EN·")+(foodPlates[i].description.ca? "":"CA·")+(foodPlates[i].description.fr? "":"FR")
		elem.dietTypes = foodPlates[i]?.dietTypes
			?.map((x) => getNonEmpty(x?.fullName))
			?.join(", ");
		elem.meals = foodPlates[i]?.meals
			?.map((x) => getNonEmpty(x?.fullName))
			?.join(", ");
		elem.calories = foodPlates[i].calories;
		elem.imageURL = foodPlates[i].imageURL;
		elem.createdAt = foodPlates[i].createdAt;
		elem.id = foodPlates[i]._id;
		elem.active = foodPlates[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function FoodPlatesPage() {
	const [data, setData] = useState([]);
	const [foodPlateId, setFoodPlateId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
	const [previewImage, setPreviewImage] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function imageFormatter(imageURL) {
		return imageURL && imageURL !== "" ? (
			<img
				src={SERVER_URL + "/" + imageURL}
				alt="foodPlate"
				style={{ width: "50px" }}
				onClick={() => {
					setPreviewImage(imageURL);
					setOpenPreviewDialog(true);
				}}
			/>
		) : (
			<div />
		);
	}

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push("/edit-plate/" + cell)}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes("admin") && (
					<>
						<Tooltip title={elem?.active ? "Disable" : "Enable"}>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setFoodPlateId(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.active ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Delete">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setFoodPlateId(cell);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{
			dataField: "imageURL",
			text: "",
			headerAlign: "center",
			align: "center",
			formatter: imageFormatter,
		},
		{
			dataField: "description",
			text: "Title",
			sort: true,
			formatter: substringFormatter,
		},
		{
			dataField: "dietTypes",
			text: "Diet Types",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "meals",
			text: "Meals",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "calories",
			text: "Calories",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "emptylanguages",
			text: "Empty",
			sort: true
		},
		{
			dataField: "createdAt",
			text: "Created at",
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getFoodPlates()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get food plates.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Food plates list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-plate")}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${
							foodPlateId?.active ? "disable" : "enable"
						} this food plate?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusFoodPlate(
								foodPlateId.id,
								!foodPlateId?.active
							)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												foodPlateId?.active
													? "Disabled!"
													: "Enabled!"
											}`,
											customMessage: `Food plate ${
												foodPlateId?.active
													? "disabled"
													: "enabled"
											} successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `Could not ${
											foodPlateId?.active
												? "disable"
												: "enable"
										} food plate.`,
									});
								});
						}}
					/>
					<ConfirmDialog
						title={
							"Are you sure you want to remove this food plate?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteFoodPlate(foodPlateId)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Food plate removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not remove food plate.",
									});
								});
						}}
					/>
					<PreviewDialog
						title={"Preview image"}
						open={openPreviewDialog}
						setOpen={setOpenPreviewDialog}
						src={
							previewImage
								? `${SERVER_URL}/${previewImage}`
								: null
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
